<template>
  <div v-if="visible">
    <dialogVue :visible="visible" @closeClick="handleCloseClick">
      <div class="memo__help__dialog">
        <div style="text-align: center; width: 100%; height: 100%">
          <div class="memo__help__dialog__carousel__header">
            <div class="memo__help__dialog__carousel__header--title">{{ $t('onboarding.dialogs.heatgrid.title') }}</div>
            <div class="memo__help__dialog__carousel__header--desc">
              {{ $t('onboarding.dialogs.heatgrid.desc') }}
            </div>
          </div>
          <img :src="img" alt="" style="width: 472px; height: 240px" />
        </div>
        <div
          class="memo__help__dialog__action"
          v-baidu-event-tracking="{ feature: '热力图_提示详情', action: '点击完成按钮' }"
          @click="closeClick"
        >
          {{ $t('onboarding.dialogs.action.done') }}
        </div>
      </div>
    </dialogVue>
  </div>
</template>
<script>
import dialogVue from './dialog.vue'
import logClickEvent from '../../../utils/logClickEvent'
import { getDurationRange } from '../../../utils/utils'
export default {
  name: 'headgridDialog',
  components: {
    dialogVue,
  },
  computed: {
    me() {
      return this.$store.state.me
    },
    visible() {
      return this.$store.getters['onboarding/heatgridHelpDialog'] == 1
    },
    isDark() {
      return document.body.classList.contains('dark_mode')
    },
    isZh() {
      return this.me ? this.me.language !== 'en' : true
    },
    img() {
      return require(`../../../../assets/images/dialogs/heatgrid_${this.isDark ? 'dark' : 'light'}_${
        this.isZh ? 'zh' : 'en'
      }.png`)
    },
  },
  data() {
    return {
      currentIndex: 0,
      startTime: 0,
    }
  },
  methods: {
    handleCloseClick() {
      logClickEvent('热力图_提示详情', '关闭')
      this.closeClick()
    },

    closeClick() {
      let endTime = new Date().getTime()
      let duration = endTime - this.startTime
      const durationRange = getDurationRange(duration)
      logClickEvent('热力图_提示详情', '在此页面停留时长', durationRange)
      this.$store.dispatch('onboarding/setHeatgridHelpDialog', '0')
    },
  },
  watch: {
    visible(val) {
      if (val) {
        // 计算显示时长
        this.startTime = new Date().getTime()
      }
    },
  },
}
</script>
